import { selectAssignment } from '@redux/experiments/selectors/index';
import type { State } from 'types/redux';

const isEligibleForWeddingsHostedCountBadge = (state: State): boolean => {
	return (
		state.vendor.vendor?.isPaid === true &&
		state.vendor.vendor?.categoryCode === 'REC'
	);
};

export const weddingsHostedCountBadgeAssignmentSelector = (state: State) => {
	if (!isEligibleForWeddingsHostedCountBadge(state)) return null;
	return selectAssignment(state, ['weddingsHostedCountBadge']);
};
